const transitionDurationMs = 425;
const section = "_086sp6bbc7";
const transition = "_086t1x22glb";
const contentWrapper = "_086c1n8nize";
const wrapper = "_086w11gy2xa";
const navButtonTrack = "_086nc4lv7l";
const navButton = "_086ndmoow2";
const fullscreenButton = "_086f1aranf7";

export { contentWrapper, fullscreenButton, navButton, navButtonTrack, section, transition, transitionDurationMs, wrapper };
import "./_content.style.linaria.module.css";
//# sourceMappingURL=_content.style.js.map
